import React, { useState } from "react";

import { EmailAddress } from "../../../../core/models/customer";

const MergeEmail: React.FunctionComponent<{
  name: string;
  onUpdate: (numbers: EmailAddress[]) => void;
  contacts: (
    | {
        name: string | undefined;
        emails: EmailAddress[];
      }
    | undefined
  )[];
}> = (props) => {
  const [emails, setEmails] = useState<EmailAddress[]>([]);
  const onSelect = (num: EmailAddress) => {
    setEmails((prevEmails: EmailAddress[]) => {
      // Check if the selected email is already in the list
      const emailExists = prevEmails.some((email) => email.email === num.email);

      if (emailExists) {
        // Remove the email if it's already present
        return prevEmails.filter((email) => email.email !== num.email);
      } else {
        // Add the email if it's not present
        return [...prevEmails, num];
      }
    });
  };
  const onPrimaryCheckChange = (num: EmailAddress) => {
    const prevEmails = emails;
    const emailExists = prevEmails.some(
      (email) => email.email === num.email && email?.isPrimary === true
    );
    let emailPrimary = [];
    if (emailExists) {
      // Remove the email if it's already present

      emailPrimary = [
        ...prevEmails
          .filter((email) => email.email !== num.email)
          ?.map((ph) => {
            return {
              isPrimary: false,
              email: ph.email,
              emailType: ph.emailType,
            };
          }),
        { isPrimary: false, email: num.email, emailType: num.emailType },
      ];
    } else {
      // Add the email if it's not present
      emailPrimary = [
        ...prevEmails
          .filter((email) => email.email !== num.email)
          ?.map((ph) => {
            return {
              isPrimary: false,
              email: ph.email,
              emailType: ph.emailType,
            };
          }),
        { isPrimary: true, email: num.email, emailType: num.emailType },
      ];
    }
    setEmails(emailPrimary);
  };
  React.useEffect(() => {
    props?.onUpdate(emails);
  }, [emails]);

  return (
    <>
      {props?.contacts?.map(
        (contact, contactIndex) =>
          contact && (
            <div key={contactIndex} className="contact">
              <div className="row">
                <div className="col-sm-11 left-wrap">
                  <p className="contact-name font-italic">{contact.name}</p>
                  {contact?.emails.map((num, index) => {
                    // Generate unique id for each radio button and checkbox
                    const radioId = `radio_${props?.name}_${contactIndex}_${index}`;
                    const checkboxId = `checkbox_${props?.name}_${contactIndex}_${index}`;
                    return (
                      <div key={index} className="d-flex mb-1">
                        <div className="contact-details w-100">
                          <span className="number font-sm font-weight-semibold d-flex align-items-center">
                            {num.email}
                          </span>
                          <span className="type font-sm border-left font-weight-semibold d-flex align-items-center">
                            {num.emailType}
                          </span>
                        </div>

                        <div className="radio-button d-flex justify-content-between align-items-center">
                          {/* Radio Button */}
                          <div className="checkbox-box border">
                            <input
                              id={radioId}
                              disabled={
                                !emails.some(
                                  (email) => email.email === num.email
                                )
                              }
                              checked={emails?.some(
                                (email) =>
                                  email.email === num.email &&
                                  email?.isPrimary === true
                              )}
                              onClick={() =>
                                onPrimaryCheckChange({
                                  isPrimary: true,
                                  emailType: num?.emailType,
                                  email: num?.email,
                                })
                              }
                              type="radio"
                              name={props.name + "radio"}
                            />
                            <label
                              htmlFor={radioId}
                              className="pl-0 w-100 h-100 justify-content-center"
                              title="Set as Primary"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="10"
                                viewBox="0 0 14 10"
                                fill="none"
                              >
                                <path
                                  d="M10.9306 0.382293L4.86025 6.45808L2.24072 3.88229C1.72802 3.3696 0.897593 3.3696 0.384624 3.88229C-0.128345 4.39499 -0.128071 5.22542 0.384624 5.73839L3.88462 9.23839C4.18759 9.4987 4.52119 9.62448 4.86025 9.62448C5.19931 9.62448 5.53181 9.49629 5.7883 9.23997L12.7883 2.23997C13.301 1.72728 13.301 0.896848 12.7883 0.383879C12.2756 -0.12909 11.4446 -0.126301 10.9306 0.382293Z"
                                  fill="#9CA3AF"
                                />
                              </svg>
                            </label>
                          </div>

                          <div className="ml-2">
                            <input
                              type="checkbox"
                              id={checkboxId}
                              name={props.name + "checkbox"}
                              onChange={() =>
                                onSelect({
                                  isPrimary: false,
                                  emailType: num?.emailType,
                                  email: num?.email,
                                })
                              }
                              checked={emails.some(
                                (email) => email.email === num.email
                              )}
                            />
                            <label className="pl-0 ml-1" htmlFor={checkboxId}>
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )
      )}
    </>
  );
};

export default MergeEmail;
